<template>
    <div>
        <div class="modal fade" id="instruction" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-body batchSummary-payment-popup text-left p-4">
                        <div class="popup-head line-head">
                            <h2 class="pb-2"> Customize your message </h2>
                        </div>
                        <div class="row normal-ib-space mt-3">
                            <div class="col-md-12 mb-3">
                                <p>Hi <span v-html="'{{name}}'"></span>! <span v-html="'{{company_name}}'"></span> has processed your salary with amount <span v-html="'{{salary}}'"></span> into your account <span v-html="'{{account_number}}'"></span> through <span v-html="'{{account_type}}'"></span></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="page-top mb-1 mb-3">
            <h1> Add Payment Message</h1>
        </div>
        <div class="global-main">
            <form id="cityForm" @submit.prevent="addPaymentMessage">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label> Account Type </label>
                        <select name="account_type" id="account_type" v-model="form.account_type" class="selectpicker custom-select2">
                            <option value="SIMSIM">SIMSIM</option>
                            <option value="BANK">BANK</option>
                            <option value="IBFT">IBFT</option>
                            <!--<option value="EMONEY">EMONEY</option>-->
                            <option value="EASY_PAISA_WALLET">EASYPAISA WALLET</option>
                            <option value="EASY_PAISA_CNIC">EASYPAISA CNIC</option>
                        </select>
                        <has-error :form="form" field="account_type"></has-error>
                    </div>

                    <div class="form-group">
                        <label> Profile Type </label>
                        <select name="account_type" id="profile_type" v-model="form.profile_type" class="selectpicker custom-select2">
                            <option value="EMPLOYEE">EMPLOYEE</option>
                            <option value="VENDOR">VENDOR</option>
                        </select>
                        <has-error :form="form" field="profile_type"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Message </label> <a href="javascript:void(0)" data-toggle="modal" data-target="#instruction">Sample</a>
                        <textarea name="text" v-model="form.text" id="" maxlength="250" placeholder="Max length : 250" cols="100" rows="10" class="form-control" :class="{ 'is-invalid': form.errors.has('text') }"></textarea>
                        <has-error :form="form" field="text"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/paymentMessages" class="btn btn-primary float-right mr-2">Back</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    account_type : '',
                    profile_type : '',
                    text : '',
                }),
            }
        },
        methods: {
            addPaymentMessage() {
                this.$Progress.start();
                this.form.post('api/addPaymentMessages')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        this.showToastBox('success','Payment Message created successfully');
                        this.$router.push('/paymentMessages');
                    }else{
                        this.$Progress.fail();
                    }
                }).then(res=>{
                    $('.selectpicker').selectpicker('refresh');
                })
                .catch(err => {
                    this.$Progress.fail();
                    this.showAlertBox('error','Some problem in your form data');
                });
            },
        },
        created() {

        },
        mounted() {
            $('.selectpicker').selectpicker('refresh');
        }
    }
</script>
